import { INVALIDATE_VENTES, INVALIDATE_DEPENSES, INVALIDATE_PRODUITS } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { ASSISTANT_IA_OPERATION_API_ROUTE } from "routes/api/endpoints";

const assistantIAApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    createAssistantIAOperation: build.mutation({
      query: (body) => ({
        url: ASSISTANT_IA_OPERATION_API_ROUTE,
        method: "POST",
        body,
      }),
      invalidatesTags: [INVALIDATE_VENTES, INVALIDATE_DEPENSES, INVALIDATE_PRODUITS],
    }),
  }),
  overrideExisting: false,
});

export const { useCreateAssistantIAOperationMutation } = assistantIAApi;
